import { StoreManagerView } from './components/StoreManagerView/StoreManagerView';
export default StoreManagerView;
